import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/management/activateRegistration/filter'; // Importing Filter component
import Response from 'views/management/activateRegistration/response'; // Importing Response component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the activate registration view.
 * @extends JetView
 */
export default class activateRegistrationView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const left = {
            css: 'int-left', // CSS class for styling
            Width: 250, // Width of the left panel
            responsiveCell: false, // Responsive behavior
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Applying theme to the toolbar
                    elements: [
                        {
                            width: 30, // Width of the button
                            css: 'back-button', // CSS class for back button
                            view: 'button', // Button component
                            type: 'icon', // Button type
                            icon: 'wxi-angle-left', // Icon for the button
                            id: 'back-button', // Unique ID for the button
                            align: 'center', // Alignment of the button
                            click: () => {
                                // Click event handler
                                $$('FilterActivateRegistration').show(); // Show filter component
                                $$('FilterActivateRegistration').clear(); // Clear filter data
                                $$('formActivateRegistration').hide(); // Hide registration form
                                $$('back-button').hide(); // Hide back button
                            },
                        },
                        { view: 'label', label: _('Activar Registro') }, // Label for the toolbar
                        {
                            type: 'wide', // Type of the element
                            css: 'close-bottom', // CSS class for close button
                            cols: [
                                {
                                    view: 'icon', // Icon component
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => this.show('/top/dashboard'), // Click event to navigate
                                },
                            ],
                        },
                    ],
                },
                Filter, // Including Filter component
                Response, // Including Response component
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique ID for the form
            type: 'clean', // Type of the view
            view: 'form', // Form component
            scroll: 'y', // Vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive behavior for the row
                    type: 'wide', // Type of the row
                    cols: [left], // Columns in the row
                },
            ],
        };
    }

    /**
     * Initializes the view components.
     */
    init() {
        $$('back-button').hide(); // Initially hide the back button
    }
}

// FILE DOCUMENTED
